import React from 'react';
import styled from 'styled-components';
import theme from '|/components/base/theme';
import ErrorFilledIcon from '|/icons/error-filled.svg';

export const OutageBannerWrapper = styled.div<{ $isVisible: boolean; children?: React.ReactNode }>`
  width: 100%;
  background-color: var(--colors-primary-yellow-1);
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  border-radius: 6px;
  justify-content: center;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transform: translateY(${({ $isVisible }) => ($isVisible ? '0' : '-10px')});
  transition: opacity 0.3s ease, transform 0.3s ease;
`;

export const BannerIcon = styled(ErrorFilledIcon)`
  width: 24px;
  height: 24px;
  flex: 0 0 auto;

  & > path {
    fill: var(--colors-primary-yellow-3) !important;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  color: var(--colors-primary-blue-6);
  text-align: center;
`;

export const BannerHeader = styled.div`
  ${theme.font.header.s}
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
`;

export const BannerDescription = styled.div`
  ${theme.font.body.m}
`;

export const CloseButton = styled.button<React.ButtonHTMLAttributes<HTMLButtonElement>>`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex: 0 0 auto;
  color: var(--colors-primary-blue-6);
  font-size: 20px;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: 2px solid var(--colors-primary-blue-3);
    outline-offset: 2px;
  }
`;